export interface ICommand { }

export class AcceptUserAccessRequestCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Organizations.Users.Commands.AcceptUserAccessRequestCommandV1, TCh.Domain.Organizations';

	Id: string;

	constructor (id: string)
	{
		this.Id = id;
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Organizations.Users.Commands.AcceptUserAccessRequestCommandV1, TCh.Domain.Organizations'
	}

}

export class AssignGlobalAdminRoleCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Organizations.Users.Commands.AssignGlobalAdminRoleCommandV1, TCh.Domain.Organizations';

	Id: string;

	constructor (id: string)
	{
		this.Id = id;
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Organizations.Users.Commands.AssignGlobalAdminRoleCommandV1, TCh.Domain.Organizations'
	}

}

export class AssignOrganizationAdminRoleCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Organizations.Users.Commands.AssignOrganizationAdminRoleCommandV1, TCh.Domain.Organizations';

	Id: string;

	constructor (id: string)
	{
		this.Id = id;
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Organizations.Users.Commands.AssignOrganizationAdminRoleCommandV1, TCh.Domain.Organizations'
	}

}

export class AssignWorkspaceUserRoleCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Organizations.Users.Commands.AssignWorkspaceUserRoleCommandV1, TCh.Domain.Organizations';

	Id: string;

	constructor (id: string)
	{
		this.Id = id;
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Organizations.Users.Commands.AssignWorkspaceUserRoleCommandV1, TCh.Domain.Organizations'
	}

}

export class ChangeOrganizationUnitCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Organizations.Users.Commands.ChangeOrganizationUnitCommandV1, TCh.Domain.Organizations';

	Id: string;
	OrganizationUnitId: number;

	constructor (id: string, organizationUnitId: number)
	{
		this.Id = id;
		this.OrganizationUnitId = organizationUnitId;
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Organizations.Users.Commands.ChangeOrganizationUnitCommandV1, TCh.Domain.Organizations'
	}

}

export class ChangePasswordCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Organizations.Users.Commands.ChangePasswordCommandV1, TCh.Domain.Organizations';

	Id: string;
	Password: string;

	constructor (id: string, password: string)
	{
		this.Id = id;
		this.Password = password;
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Organizations.Users.Commands.ChangePasswordCommandV1, TCh.Domain.Organizations'
	}

}

export class CreateUserCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Organizations.Users.Commands.CreateUserCommandV1, TCh.Domain.Organizations';

	Id: string;
	OrganizationUnitId: number;
	Email: string;
	FirstName: string;
	LastName: string;
	IsGlobalAdmin: boolean;
	IsOrganizationAdmin: boolean;
	IsWorkspaceUser: boolean;
	SetInitialPassword: boolean;
	Password: any;

	constructor (id: string, organizationUnitId: number, email: string, firstName: string, lastName: string, isGlobalAdmin: boolean, isOrganizationAdmin: boolean, isWorkspaceUser: boolean, setInitialPassword: boolean, password: any)
	{
		this.Id = id;
		this.OrganizationUnitId = organizationUnitId;
		this.Email = email;
		this.FirstName = firstName;
		this.LastName = lastName;
		this.IsGlobalAdmin = isGlobalAdmin;
		this.IsOrganizationAdmin = isOrganizationAdmin;
		this.IsWorkspaceUser = isWorkspaceUser;
		this.SetInitialPassword = setInitialPassword;
		this.Password = password;
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Organizations.Users.Commands.CreateUserCommandV1, TCh.Domain.Organizations'
	}

}

export class DisableUserCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Organizations.Users.Commands.DisableUserCommandV1, TCh.Domain.Organizations';

	Id: string;

	constructor (id: string)
	{
		this.Id = id;
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Organizations.Users.Commands.DisableUserCommandV1, TCh.Domain.Organizations'
	}

}

export class EnableUserCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Organizations.Users.Commands.EnableUserCommandV1, TCh.Domain.Organizations';

	Id: string;

	constructor (id: string)
	{
		this.Id = id;
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Organizations.Users.Commands.EnableUserCommandV1, TCh.Domain.Organizations'
	}

}

export class LockUserCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Organizations.Users.Commands.LockUserCommandV1, TCh.Domain.Organizations';

	Id: string;
	Reason: string;
	UnlockAt: any;

	constructor (id: string, reason: string, unlockAt: any)
	{
		this.Id = id;
		this.Reason = reason;
		this.UnlockAt = unlockAt;
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Organizations.Users.Commands.LockUserCommandV1, TCh.Domain.Organizations'
	}

}

export class RejectUserAccessRequestCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Organizations.Users.Commands.RejectUserAccessRequestCommandV1, TCh.Domain.Organizations';

	Id: string;

	constructor (id: string)
	{
		this.Id = id;
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Organizations.Users.Commands.RejectUserAccessRequestCommandV1, TCh.Domain.Organizations'
	}

}

export class RequestResetPasswordCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Organizations.Users.Commands.RequestResetPasswordCommandV1, TCh.Domain.Organizations';

	Email: string;

	constructor (email: string)
	{
		this.Email = email;
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Organizations.Users.Commands.RequestResetPasswordCommandV1, TCh.Domain.Organizations'
	}

}

export class RequestSsoUrlCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Organizations.Users.Commands.RequestSsoUrlCommandV1, TCh.Domain.Organizations';

	Id: string;

	constructor (id: string)
	{
		this.Id = id;
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Organizations.Users.Commands.RequestSsoUrlCommandV1, TCh.Domain.Organizations'
	}

}

export class RequestUserAccessCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Organizations.Users.Commands.RequestUserAccessCommandV1, TCh.Domain.Organizations';

	Id: string;
	OrganizationUnitId: number;
	RequestedBy: string;
	Email: string;
	FirstName: string;
	LastName: string;
	DisplayName: string;

	constructor (id: string, organizationUnitId: number, requestedBy: string, email: string, firstName: string, lastName: string, displayName: string)
	{
		this.Id = id;
		this.OrganizationUnitId = organizationUnitId;
		this.RequestedBy = requestedBy;
		this.Email = email;
		this.FirstName = firstName;
		this.LastName = lastName;
		this.DisplayName = displayName;
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Organizations.Users.Commands.RequestUserAccessCommandV1, TCh.Domain.Organizations'
	}

}

export class ResetPasswordCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Organizations.Users.Commands.ResetPasswordCommandV1, TCh.Domain.Organizations';

	Id: string;
	SendPasswordToEmail: string;

	constructor (id: string, sendPasswordToEmail: string)
	{
		this.Id = id;
		this.SendPasswordToEmail = sendPasswordToEmail;
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Organizations.Users.Commands.ResetPasswordCommandV1, TCh.Domain.Organizations'
	}

}

export class RevokeGlobalAdminRoleCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Organizations.Users.Commands.RevokeGlobalAdminRoleCommandV1, TCh.Domain.Organizations';

	Id: string;

	constructor (id: string)
	{
		this.Id = id;
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Organizations.Users.Commands.RevokeGlobalAdminRoleCommandV1, TCh.Domain.Organizations'
	}

}

export class RevokeOrganizationAdminRoleCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Organizations.Users.Commands.RevokeOrganizationAdminRoleCommandV1, TCh.Domain.Organizations';

	Id: string;

	constructor (id: string)
	{
		this.Id = id;
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Organizations.Users.Commands.RevokeOrganizationAdminRoleCommandV1, TCh.Domain.Organizations'
	}

}

export class RevokeWorkspaceUserRoleCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Organizations.Users.Commands.RevokeWorkspaceUserRoleCommandV1, TCh.Domain.Organizations';

	Id: string;

	constructor (id: string)
	{
		this.Id = id;
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Organizations.Users.Commands.RevokeWorkspaceUserRoleCommandV1, TCh.Domain.Organizations'
	}

}

export class SignInCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Organizations.Users.Commands.SignInCommandV1, TCh.Domain.Organizations';

	Id: string;
	Password: string;
	ReturnUrl: string;

	constructor(id: string, password: string, returnUrl: string = null)
	{
		this.Id = id;
		this.Password = password;
		this.ReturnUrl = returnUrl;
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Organizations.Users.Commands.SignInCommandV1, TCh.Domain.Organizations'
	}

}

export class SignoutFromAllSessionsCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Organizations.Users.Commands.SignoutFromAllSessionsCommandV1, TCh.Domain.Organizations';

	Id: string;

	constructor (id: string)
	{
		this.Id = id;
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Organizations.Users.Commands.SignoutFromAllSessionsCommandV1, TCh.Domain.Organizations'
	}

}

export class SignoutFromSessionCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Organizations.Users.Commands.SignoutFromSessionCommandV1, TCh.Domain.Organizations';

	Id: string;
	SessionId: string;

	constructor (id: string, sessionId: string)
	{
		this.Id = id;
		this.SessionId = sessionId;
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Organizations.Users.Commands.SignoutFromSessionCommandV1, TCh.Domain.Organizations'
	}

}

export class UnlockUserCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Organizations.Users.Commands.UnlockUserCommandV1, TCh.Domain.Organizations';

	Id: string;

	constructor (id: string)
	{
		this.Id = id;
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Organizations.Users.Commands.UnlockUserCommandV1, TCh.Domain.Organizations'
	}

}

export class UpdateUserDetailsCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Organizations.Users.Commands.UpdateUserDetailsCommandV1, TCh.Domain.Organizations';

	Id: string;
	FirstName: string;
	LastName: string;
	DisplayName: string;

	constructor (id: string, firstName: string, lastName: string, displayName: string)
	{
		this.Id = id;
		this.FirstName = firstName;
		this.LastName = lastName;
		this.DisplayName = displayName;
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Organizations.Users.Commands.UpdateUserDetailsCommandV1, TCh.Domain.Organizations'
	}

}

